import { SET_POST_OFFICES } from '../../constants/ActionTypes';

const INIT_STATE = {
  postOffice: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_POST_OFFICES: {
      return { ...state, postOffice: action.payload };
    }

    default:
      return state;
  }
};
